// src/App.js
import React, { Component } from "react";
import "./App.scss";
import { Routes, Route } from "react-router-dom";

import { withTranslation } from "react-i18next";
import { withRouter } from "./withRouter"; // ton HOC custom

import PrivateRoute3 from "./PrivateRoute3";
import App2 from "./App2";
import { setAlert } from "./actions/alert3";
import Login2 from "./user-pages/Login2";
import Dashboard2 from "./dashboard/Dashboard2";
import Connectclts from "./user-pages/Connectclts";
import Home from "./user-pages/Home";
import Connectemp from "./user-pages/Connectemp";
import Fenmenu from "./user-pages/Fenmenu";
import Empwork from "./user-pages/Empwork";
import Tabsuiclients from "./user-pages/Tabsuiclients";
import Empctrlwork from "./user-pages/Empctrlwork";
import CreateUserForm from "./user-pages/CreateUserForm";

class App extends Component {
  componentDidMount() {
    // On écoute le stockage local pour les alertes
    window.addEventListener("storage", this.handleStorageEvent);
  }

  componentWillUnmount() {
    window.removeEventListener("storage", this.handleStorageEvent);
  }

  handleStorageEvent = (e) => {
    if (e.key === "alertEvent" && e.newValue) {
      try {
        const { message, type, id } = JSON.parse(e.newValue);
        // On dispatche vers Redux
        this.props.dispatch({
          type: "SET_ALERT",
          payload: { message, type, id },
        });
      } catch (err) {
        console.error("Erreur parsing alerte :", err);
      }
    }
  };

  render() {
    return (
      <div className="container-scroller">
        <Routes>
          {/* ✅ Routes publiques */}
          <Route path="/cms" element={<Dashboard2 />} />
          <Route path="/login" element={<Login2 />} />
          <Route path="/clogin" element={<Home />} />
           <Route path="/prepage" element={<Connectclts />} />
          <Route path="/loginc" element={<Connectemp />} />
          <Route path="/uf" element={<CreateUserForm />} />
          <Route path="/empw" element={<Empwork />} />

          {/* ✅ Toutes les autres routes passent par App2 et sont protégées   <BrowserRouter basename="/Nadine_Braiding">*/}
          <Route
            path="/*"
            element={
              <PrivateRoute3>
                <App2 />
              </PrivateRoute3>
            }
          />
        </Routes>
      </div>
    );
  }
}

export default withTranslation()(withRouter(App));